export const V1_SET_USER_CUSTOM_TOP_CODE_FROM_SESSION_STORE =
  'V1_SET_USER_CUSTOM_TOP_CODE_FROM_SESSION_STORE'

export default data => {
  return {
    type: V1_SET_USER_CUSTOM_TOP_CODE_FROM_SESSION_STORE,
    data,
  }
}
